// Import the functions you need from the SDKs you need
import { getAnalytics } from "firebase/analytics"
import { initializeApp } from "firebase/app"

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey            : "AIzaSyCOvE1CwS9pZIqkLjrqNs5J1fOEPihk3IA",
    authDomain        : "daudit-145c2.firebaseapp.com",
    databaseURL       : "https://daudit-145c2-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId         : "daudit-145c2",
    storageBucket     : "daudit-145c2.appspot.com",
    messagingSenderId : "549497773127",
    appId             : "1:549497773127:web:2b737b741bf45c87542562",
    measurementId     : "G-Y5D8X00KV5"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig)

const analytics = getAnalytics(app)
export {analytics}
export default app
